module.exports = __webpack_public_path__ + "61c081c8a356fe80a00f53f9100823b2.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/Rummelsnuff.jpg
// module id = 575
// module chunks = 0